import React from 'react';
import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled component for the animated skeleton
const SkeletonBar = styled(Box)(({ width = '80%' }) => ({
  height: '16px',
  backgroundColor: 'rgb(200, 200, 200)',
  borderRadius: '4px',
  width: width,
  animation: 'pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%': {
      opacity: 1,
    },
    '50%': {
      opacity: 0.4,
    },
    '100%': {
      opacity: 1,
    },
  },
}));

// Header skeleton bar - slightly taller
const HeaderSkeletonBar = styled(SkeletonBar)({
  height: '20px',
  backgroundColor: 'rgb(180, 180, 180)',
});

const BookingListSkeleton = () => {
  // Column widths matching your actual grid
  const columnWidths = [3, 2, 2, 1, 2, 2];
  
  return (
    <Box>
      {/* Header skeleton */}
      <Grid
        container
        spacing={2}
        sx={{
          alignItems: 'center',
          borderBottom: '1px solid',
          borderColor: 'divider',
          pb: 1,
          mb: 2
        }}
      >
        {columnWidths.map((width, index) => (
          <Grid key={`header-${index}`} item xs={width}>
            <HeaderSkeletonBar />
          </Grid>
        ))}
      </Grid>

      {/* Row skeletons */}
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
        <Grid
          container
          spacing={2}
          key={`row-${row}`}
          sx={{
            height: '40px',
            alignItems: 'center',
            mb: 1
          }}
        >
          {columnWidths.map((width, index) => (
            <Grid key={`cell-${row}-${index}`} item xs={width}>
              <SkeletonBar 
                width={index === 5 ? '40%' : '80%'} // Last column (actions) is shorter
              />
            </Grid>
          ))}
        </Grid>
      ))}
    </Box>
  );
};

export default BookingListSkeleton;